// ** React Import
import { useRef, useState } from 'react'

// ** Full Calendar & it's Plugins
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'

import { useTranslation } from 'react-i18next'

import { Card, CardBody, Modal, ModalBody, ModalHeader, Row, Col, Spinner } from 'reactstrap'

import useWindowDimensions from '@student_components/useWindowDimensions'

import moment from 'moment'

import styled from "@emotion/styled";

export const StyleWrapper = styled.div`
  .fc-event-title {
    font-size: 10px;
    white-space: pre-wrap;
  }
  .fc-timegrid-slot {
    height: 3.5rem !important
  }
`;

const Calendar = props => {
    // ** Refs
    const calendarRef = useRef(null)

    const { t } = useTranslation()

    // Дэлгэцний өргөн, өндөр авах
    const { width } = useWindowDimensions()

    // ** Props
    const {
        isRtl,
        eventDatas,
        isLoading,
    } = props

    const [popoverOpen, setPopoverOpen] = useState(false)
    const [datas, setDatas] = useState([])

    function handlePop() {
        setPopoverOpen(!popoverOpen)
    }

    const calendarOptions = {
        events: eventDatas && eventDatas.length > 0 ? eventDatas : [],
        plugins: [timeGridPlugin],
        initialView: 'timeGridWeek',
        firstDay: 1,
        dragScroll: true,
        dayMaxEvents: 3,
        allDaySlot: false,
        slotMinTime: "09:00",
        slotMaxTime: "22:00",
        slotDuration: '01:40:00',
        slotLabelFormat: function (data)
        {
            var hours = moment(data.date)
            if (hours.format("HH:mm") == '12:20')
            {
                hours = hours.add(50, 'minutes')
            }

            if (hours.format("HH:mm") == '14:00' || hours.format("HH:mm") == '15:40' || hours.format("HH:mm") == '17:20' || hours.format("HH:mm") == '19:00' || hours.format("HH:mm") == '20:40')
            {
                hours = hours.add(50, 'minutes')
            }

            return hours.format("HH:mm") + " ~ " + hours.add(90, 'minutes').format("HH:mm");
        },
        navLinks: true,
        buttonText: {
            today: t('Өнөөдөр'),
            month: t('Сар'),
            week: t('7 хоног'),
            day: t('Өдөр'),
        },
        headerToolbar: false,
        views: {
            dayGridMonth: { // name of view
                titleFormat: ({date}) => {
                    const months = [t('1 сар'), t('2 сар'), t('3 сар'), t('4 сар'), t('5 сар'), t('6 сар'), t('7 сар'), t('8 сар'), t('9 сар'), t('10 сар'), t('11 сар'), t('12 сар')]

                    var now_month = date.month
                    var now_year = date.year
                    var full_title = months[now_month] + ' ' + now_year

                    return full_title
                },
            }
        },
        nowIndicator: true,
        dayHeaderContent: ({date}) => {
            const fd = date.getDay()
            const days = [t('Ня'), t('Да'), t('Мя'), t('Лх'), t('Пү'), t('Ба'), t('Бя')]
            if (width < 1000) {
                return days[fd]
            }
            const weekdays = [t('Ням'), t('Даваа'), t('Мягмар'), t('Лхагва'), t('Пүрэв'), t('Баасан'), t('Бямба')]
            return weekdays[fd]
        },
        dayMaxEventRows: true,

        displayEventTime: false,

        ref: calendarRef,
        direction: isRtl ? 'rtl' : 'ltr',
        eventClick: function(info, event) {
            setDatas(info.event.extendedProps)
            handlePop()
        },
        eventShortHeight: 15,
    }

    return (
        <Card className='shadow-none border-0 mb-0 rounded-0'>
            <CardBody className='pb-0'>
                {
                    isLoading &&
                    <div className='suspense-loader'>
                        <Spinner size='bg'/>
                        <span className='ms-50'>{t('Түр хүлээнэ үү...')}</span>
                    </div>
                }
                <StyleWrapper>
                    <FullCalendar {...calendarOptions} />{' '}
                </StyleWrapper>
            </CardBody>
            <Modal isOpen={popoverOpen} toggle={handlePop} className="modal-dialog-centered modal-sm">
                <ModalHeader toggle={handlePop}>{t('Хичээлийн дэлгэрэнгүй')}</ModalHeader>
                <ModalBody>
                    {
                        datas && Object.keys(datas).length > 0
                        ?
                            <>
                                <Row tag='dl' className='mb-0'>
                                    <Col tag='dt' xs='4' className='fw-bolder mb-1'>
                                        Хичээл:
                                    </Col>
                                    <Col tag='dd' xs='8' className='mb-1'>
                                        {datas?.lesson?.code + ' ' + datas?.lesson?.name + ' ' + `(${datas?.type})` || 'Хоосон байна'}
                                    </Col>
                                </Row>
                                <Row tag='dl' className='mb-0'>
                                    <Col tag='dt' xs='4' className='fw-bolder mb-1'>
                                        Анги:
                                    </Col>
                                    <Col tag='dd' xs='8' className='mb-1'>
                                        {datas?.room?.code + ' ' + datas?.room?.name || 'Хоосон байна'}
                                    </Col>
                                </Row>
                                <Row tag='dl' className='mb-0'>
                                    <Col tag='dt' xs='4' className='fw-bolder mb-1'>
                                        Багш:
                                    </Col>
                                    <Col tag='dd' xs='8' className='mb-1'>
                                        {(datas?.teacher?.full_name) || 'Хоосон байна'}
                                    </Col>
                                </Row>
                            </>
                        :
                            <p className='text-center'>Мэдээлэл олдсонгүй</p>
                    }
                </ModalBody>
            </Modal>
        </Card>
    )
}

export default Calendar
